import React, { useEffect } from "react";
import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import { Outlet } from "react-router";
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import AppSidebar from "./AppSidebar";
import { useSettings } from "../context/SettingsContext";

const LayoutContent: React.FC = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();
  const { settings } = useSettings();

  useEffect(() => {
    const rawName = settings.logoName;
    const trimmedName = rawName?.trim();

    const isValidName =
      trimmedName &&
      trimmedName.toLowerCase() !== "null" &&
      trimmedName.toLowerCase() !== "undefined" &&
      trimmedName !== "";

    document.title = isValidName
      ? `${trimmedName} | Powered by KloudData`
      : "Powered by KloudData";
  }, [settings.logoName]);

  useEffect(() => {
    const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;

    if (favicon) {
      const logoPath = settings.logoPath?.trim();
      if (logoPath && logoPath !== "null" && logoPath !== "undefined") {
        favicon.href = logoPath;
      }
    }
  }, [settings.logoPath]);

  return (
    <div className="w-full max-w-screen">
      <AppSidebar />
      <div
        className={`flex-1 transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "lg:ml-[240px]" : "lg:ml-[80px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        <Backdrop />
        <AppHeader />
        {/* <div className="p-4 mx-auto max-w-screen-2xl md:p-6"> */}
        <div className="p-4 w-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const AppLayout: React.FC = () => {
  const { settings } = useSettings();
  return (
    <SidebarProvider>
      <LayoutContent key={settings.logoPath} />
    </SidebarProvider>
  );
};

export default AppLayout;
